import i18next from "i18next";
import {
    COMMUNICTAION_PREFERENCES,
    LANGUAGE,
    LANGUAGES,
    PHONE_TYPE,
    VALIDATIONS,
} from "../../utils/constants";
import {translatedRadioOptions, translatedYesNoValues, optionValues, radioOptionValues, todayEndOfDay} from "../../utils/utils";

export const getFormFields = (formData, states, t, tv) => {
    const selectedLanguage = i18next.language || "en";
    const languageOptions = radioOptionValues(LANGUAGES, true).map(option => ({
        ...option,
        label: tv(`${option.id}`) 
    }));
    const updatedLanguageOptions = languageOptions.map((option) => (option.id === LANGUAGES.Other ? {...option, customRender: true} : option));
    const sectionStyle = 'h4 fw-normal text-muted mt-4';
    const noPhoneSelected = Array.isArray(formData?.noPhone) && formData.noPhone.includes("noPhoneNumber"); 

    let step1Fields = [
        { type: 'section', name: 'contact', label: t("contactInformation"), customClass: sectionStyle },
        { type: 'subheader', name: 'requiredInfo', label: t("requiredInfoText"), customClass: 'small text-muted mb-3 mt-n1' },
        { type: "text", name: "firstName", label: t("firstName"), isRequired: true, maxLength: 35, valid: selectedLanguage === LANGUAGE.Spanish ? VALIDATIONS.String.isSpanishName : VALIDATIONS.String.isName },
        { type: "text", name: "lastName", label: t("lastName"), isRequired: true, maxLength: 35, valid: selectedLanguage === LANGUAGE.Spanish ? VALIDATIONS.String.isSpanishName : VALIDATIONS.String.isName },
        { type: "text", name: "applicationHealthPlanId", label: t("customerId"), maxLength: 16 },
        { type: "text", name: "address", label: t("address"), isRequired: true, maxLength: 35 },
        { type: "text", name: "address2", label: t("address2"),  maxLength: 35 },
        { type: "text", name: "city", label: t("city"), isRequired: true, maxLength: 50 },
        { type: "options", name: "state", label: t("state"), optionValues: optionValues(states, !formData.state || formData.state === '', tv('select')), isRequired: true, maxLength: 2, minLength: 2 },
        { type: "number", name: "postalCode", label: t("postalCode"), isRequired: true, minLength: 5, maxLength: 9, valid: VALIDATIONS.Number.isZipCode },
        { type: "email", name: "email", label: t("email"), maxLength: 255, valid: VALIDATIONS.String.isEmail },        
        { type: "date", name: "birthday", label: t("birthday"), placeholder: t("birthdayPlaceholder"), isRequired: true, maxValue: todayEndOfDay() },
        { type: "tel", name: "phone", label: t("phone"), isRequired: !noPhoneSelected, disabled: noPhoneSelected, dependsOn: "noPhone", dependsValue: "noPhoneNumber", maxLength: 10, removeSpacing: true, showCustomError: true },
        {
            type: "checkbox",
            name: "noPhone",
            label: "",
            disabled: !!formData?.phone,
            hideLabel: true,
            optionValues: [{ id: "noPhoneNumber", label: t("noPhoneNumber"), value: "noPhoneNumber" }]
        },
        { type: "radio", name: "phoneType", label: t("phoneType"), optionValues:  translatedRadioOptions(tv, PHONE_TYPE), disabled: noPhoneSelected, dependsOn: "noPhone", dependsValue: "noPhoneNumber" },
        { type: "checkbox", name: "communicationPreference", label: t("communicationPreference"), optionValues: translatedRadioOptions(tv, COMMUNICTAION_PREFERENCES)                            },
        // Step 2
        { type: 'section', name: 'accessibility', label: t('accessibility'), customClass: `${sectionStyle} mt-5` },
        { type: "radio", name: "primaryLanguage", label: t("primaryLanguage"), hasCustomRender: true, customRenders: [LANGUAGES.Other], optionValues: updatedLanguageOptions },
        { type: "radio", name: "needTranslator", label: t("needTranslator"), optionValues: translatedYesNoValues(tv) },
        { type: "radio", name: "needTransportation", label: t("needTransportation"), optionValues: translatedYesNoValues(tv, [{ id: 'someTimes', label: "someTimes", value: "someTimes" }]) },
        { type: "radio", name: "deviceWithInternetAccess", label: t("deviceWithInternetAccess"), optionValues: translatedYesNoValues(tv, [{ id: 'notSure', label: "notSure", value: "notSure" }]) },
        { type: "radio", name: "specificAccommodation", label: t("specificAccommodation"), optionValues: translatedYesNoValues(tv) },
        {
            type: "text", name: "specificAccommodationNeeds", label: t("specificAccommodationNeeds"), maxLength: 50,
            hidden: true,
            conditional: true,
            dependsOn: 'specificAccommodation',
            dependsValue: ['Y']
        },
        { type: "radio", name: "dietaryRestrictionsAccommodation", label: t("dietaryRestrictionsAccommodation"), optionValues: translatedYesNoValues(tv) },
        {
            type: "text", name: "dietaryRestrictionsNeeds", label: t("dietaryRestrictionsNeeds"), maxLength: 50,
            hidden: true,
            conditional: true,
            dependsOn: 'dietaryRestrictionsAccommodation',
            dependsValue: ['Y']
        },
        { type: 'section', name: 'emergency', label: t('emergency'), customClass: `${sectionStyle} mt-5` },
        { type: "text", name: "emergencyFirstName", label: t("emergencyFirstName"), maxLength: 35 },
        { type: "text", name: "emergencyLastName", label: t("emergencyLastName"), maxLength: 35 },
        { type: "text", name: "relationshipEmergency", label: t("relationshipEmergency"), maxLength: 35 },
        { type: "tel", name: "phoneEmergency", label: t("phoneEmergency"), maxLength: 10 },
        { type: "radio", name: "phoneTypeEmergency", label: t("phoneTypeEmergency"), optionValues: translatedRadioOptions(tv, PHONE_TYPE) },
        { type: 'section', name: 'about', label: t('aboutYou'), customClass: `${sectionStyle} mt-5` },
        { type: "textarea", name: "participateReason", label: t("participateReason"), maxLength: 255, showCharCounter: true, valid: VALIDATIONS.String.noSpecialChars },
    ];

    let step2Fields = [];

    return {
        step1Fields,
        step2Fields
    }
}
